import React, { useContext } from "react";
import { LanguageContext } from "../languages/languageContext";

interface Props {
  language: string;
}

const LanguageTag = ({ language }: Props) => {
  const courses = useContext(LanguageContext).courses;

  return (
    <span
      className={`absolute top-7 -left-9 z-50 w-[150px] rotate-[-45deg] rounded border-t border-b ${
        language === "portuguese"
          ? "bg-green-700"
          : language === "spanish"
          ? "bg-orange-700"
          : language === "english"
          ? "bg-red-700"
          : language === "french"
          ? "bg-blue-700"
          : ""
      }  px-5 text-center text-base text-white`}
    >
      {language === "portuguese"
        ? courses.languagePortuguese
        : language === "english"
        ? courses.languageEnglish
        : language === "french"
        ? courses.languageFrench
        : language === "spanish"
        ? courses.languageSpanish
        : ""}
    </span>
  );
};

export default LanguageTag;
